import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GiantConfigService } from '../admin-layout/services/config-service';
import { UserRepository } from 'src/app/repositories/user/UserRepository';
import { Router, NavigationExtras } from '@angular/router';
import { Validators, UntypedFormBuilder, FormGroup } from '@angular/forms';
import { LoginRepository } from 'src/app/repositories/login/LoginRepository';
import { Login } from 'src/app/models/login.model';
import { MatRadioButton } from "@angular/material/radio";
import { giantAnimations } from '../admin-layout/animations';
import { Usertf } from 'src/app/models/Usertf.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GiantSnackBarService } from 'src/app/shared/utils/giant-snack-bar';
@Component({
  selector: 'tf-authentication',
  templateUrl: './tf-authentication-layout.component.html',
  styleUrls: ['./tf-authentication-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: giantAnimations
})
export class TfAuthenticationLayoutComponent implements OnInit {


  userModel = new Usertf();
  PhoneNumber :string;
  Email : string
    constructor(
        private _giantConfigService: GiantConfigService,
        private _formBuilder: UntypedFormBuilder,
        private _loginRepository: LoginRepository,
        private _router: Router,
        private _userRepository: UserRepository,
        private _giantSnackBarService: GiantSnackBarService,
    
        //private snackBar: MatSnackBar
    ) {
        // Configure the layout
        this._giantConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        
        this._userRepository.GetUsersById().subscribe((res: any) => {
        var mobile = "****";
        var email = "*********"
            res.UserDetail.map(user => {
              
                this.userModel = user;
               this.PhoneNumber = this.userModel.PhoneNo; 
               this.Email = this.userModel.Email;
                if(this.userModel.PhoneNo.length>3)
                {
                  var Mobilephone = this.userModel.PhoneNo.substring(this.userModel.PhoneNo.length - 3);
                  this.userModel.PhoneNo =  mobile+ Mobilephone
                }
                  var EmailAddress = this.userModel.Email.substring(this.userModel.Email.indexOf('@'));
                  this.userModel.Email =  email+EmailAddress
                
            });
          });
    }


    SendAuthenticationCode(){
      
   
        if (this.userModel.Type == undefined)
        {
            this._giantSnackBarService.snackbarError("No verification code delivery method is available for you. please contact administrator.");
            return;
        }

        if(this.userModel.Type == "Email")
        {
            this.userModel.AuthType = '1'
            this.userModel.AuthChannelValue = this.Email
        }
        else 
        {
            this.userModel.AuthType = '2'
            this.userModel.AuthChannelValue = this.PhoneNumber
        }
        this._userRepository.SendAuthenticationCode(this.userModel).subscribe((res: any) => {

          if(res.UserDetail[0].ErrorCode == 0)
          {

            this._giantSnackBarService.snackbarSuccess(res.UserDetail[0].ErrorMessage);

            let navigationExtras: NavigationExtras = {
              queryParams: {
                  "type"   : encodeURIComponent(this.userModel.Type),
              }
          };
          

            this._router.navigate(['/tf-verfiyCode'], navigationExtras);
          }
          else 
          {
            this._giantSnackBarService.snackbarError(res.UserDetail[0].ErrorMessage);
            return;
          }
        });

}

// openSnackBar(message: string, action: string) {
//     this.snackBar.open(message, action, {
//         duration: 3000,
    
//         verticalPosition: "top"
//     });
//   }
}
